const STORAGE_PREFIX = 'multas_fine_notif_viewed_';

function storageKey(
  userKey: string,
  sessionAnchor: string | null | undefined,
): string {
  return `${STORAGE_PREFIX}${userKey}_${sessionAnchor ?? 'none'}`;
}

export function readViewedFineNotificationIds(
  userKey: string | null | undefined,
  sessionAnchor: string | null | undefined,
): Set<string> {
  if (!userKey) return new Set();
  try {
    const raw = localStorage.getItem(storageKey(userKey, sessionAnchor));
    if (!raw) return new Set();
    const parsed = JSON.parse(raw) as string[];
    if (!Array.isArray(parsed)) return new Set();
    return new Set(parsed.filter(Boolean));
  } catch {
    return new Set();
  }
}

export function markFineNotificationViewed(
  userKey: string | null | undefined,
  fineId: string,
  sessionAnchor: string | null | undefined,
): void {
  if (!userKey || !fineId) return;
  const viewed = readViewedFineNotificationIds(userKey, sessionAnchor);
  viewed.add(fineId);
  try {
    localStorage.setItem(
      storageKey(userKey, sessionAnchor),
      JSON.stringify(Array.from(viewed)),
    );
  } catch {
    /* ignore quota / private mode */
  }
}
